// import apiClient from "../utils/Http";

// // ✅ WORKING - Keep these
// export const getCourseLessonProgress = (courseId) => apiClient.get(`/api/lesson-progress/course/?course_id=${courseId}`);
// export const getEnrollmentLessonProgress = (enrollmentId) => apiClient.get(`/api/lesson-progress/enrollment/?enrollment_id=${enrollmentId}`);
// export const updateBulkLessonProgress = (courseId, progressData) => {
//   const payload = {
//     course_id: courseId,
//     progress: progressData
//   };
//   return apiClient.put(`/api/lesson-progress/bulk-update/`, payload);
// };

// export const getCourseProgressSummary = (courseId) => apiClient.get(`/api/course-progress/summary/?course_id=${courseId}`);

// // ✅ FIXED: Add validation and ensure lessonId is a number
// export const trackLessonProgress = (lessonId, data) => {
//   // Convert lessonId to number and validate
//   const validatedLessonId = parseInt(lessonId);
  
//   if (isNaN(validatedLessonId) || validatedLessonId <= 0) {
//     return Promise.reject(new Error('Invalid lesson ID'));
//   }

//   const payload = {
//     lesson_id: validatedLessonId, // Ensure it's a number
//     tracked_time: data.current_time || 0,
//     completed: Boolean(data.completed),
//     progress_percentage: data.progress_percentage || 0
//   };
  
//   return apiClient.post(`/api/lesson-progress/track/`, payload);
// };

// export const getLastPlayedLesson = (courseId) => apiClient.get(`/api/lesson-progress/last-played/?course_id=${courseId}`);
// export const getUserEnrollment = (courseId) => apiClient.get(`/api/enrollments/user-enrollment/?course_id=${courseId}`);

import apiClient from "../utils/Http";

// ==================== COURSE-SCOPED (slug) ====================
// These views take a course slug because the caller is on a public
// course page (/course/:slug or /content/:slug).

export const getCourseLessonProgress = (courseSlug) =>
  apiClient.get('/api/lesson-progress/course/', {
    params: { course_slug: courseSlug },
  });

export const getCourseProgressSummary = (courseSlug) =>
  apiClient.get('/api/course-progress/summary/', {
    params: { course_slug: courseSlug },
  });

export const getLastPlayedLesson = (courseSlug) =>
  apiClient.get('/api/lesson-progress/last-played/', {
    params: { course_slug: courseSlug },
  });

export const getUserEnrollment = (courseSlug) =>
  apiClient.get('/api/enrollments/user-enrollment/', {
    params: { course_slug: courseSlug },
  });

export const updateBulkLessonProgress = (courseSlug, progressData) => {
  const payload = {
    course_slug: courseSlug,      // <-- was course_id
    progress: progressData,
  };
  return apiClient.put('/api/lesson-progress/bulk-update/', payload);
};

// ==================== ENROLLMENT-SCOPED (pk) ====================
// Dashboard/internal. Enrollment id is not a URL-visible value.

export const getEnrollmentLessonProgress = (enrollmentId) =>
  apiClient.get('/api/lesson-progress/enrollment/', {
    params: { enrollment_id: enrollmentId },
  });

// ==================== LESSON-SCOPED (pk) ====================
// Lesson progress tracking always uses numeric lesson id.

export const trackLessonProgress = (lessonId, data) => {
  const validatedLessonId = parseInt(lessonId, 10);

  if (isNaN(validatedLessonId) || validatedLessonId <= 0) {
    return Promise.reject(new Error('Invalid lesson ID'));
  }

  const payload = {
    lesson_id: validatedLessonId,
    tracked_time: data.current_time || 0,
    completed: Boolean(data.completed),
    progress_percentage: data.progress_percentage || 0,
  };

  return apiClient.post('/api/lesson-progress/track/', payload);
};